class QuestionnaireBuilder {
    static newQuestionnaire() {
        return new QuestionnaireBuilder();
    }
}


export default QuestionnaireBuilder;